import PropTypes from 'prop-types'
import React from 'react'
import Card from '../../Card/Card'
import Content from './Content'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalDownload = ({ download }) => {
  const { image, file, authorAlt, title } = download

  const url = file ? file.url : null

  return (
    <Card iconName="pdf" image={image} url={url}>
      <Content author={authorAlt} title={title} />
    </Card>
  )
}

PortalDownload.propTypes = {
  download: PropTypes.object.isRequired,
}

export default PortalDownload
